(() => {
  if (window.__REAL_PRODUCT_CARD_CAROUSEL__) {
    return;
  }

  window.__REAL_PRODUCT_CARD_CAROUSEL__ = true;


  /*
   * ----------------------------------------------------------
   * HELPERS
   * ----------------------------------------------------------
   */

  const getCarouselFromViewport = (viewport) => {
    return viewport?.closest(
      '[data-product-card-carousel]'
    );
  };


  const getSlides = (viewport) => {
    return Array.from(
      viewport.querySelectorAll(
        '[data-product-card-carousel-slide]'
      )
    );
  };


  const getIndex = (viewport) => {
    if (
      !viewport ||
      viewport.clientWidth <= 0
    ) {
      return 0;
    }

    return Math.round(
      viewport.scrollLeft /
      viewport.clientWidth
    );
  };


  /*
   * ----------------------------------------------------------
   * UPDATE DOTS + BUTTON STATES
   * ----------------------------------------------------------
   */

  const updateUI = (viewport) => {
    const carousel =
      getCarouselFromViewport(viewport);

    if (!carousel) {
      return;
    }


    const slides =
      getSlides(viewport);


    if (!slides.length) {
      return;
    }


    const index =
      Math.max(
        0,
        Math.min(
          slides.length - 1,
          getIndex(viewport)
        )
      );


const counter =
  carousel.querySelector(
    '[data-product-card-carousel-counter]'
  );


if (counter) {

  const current =
    String(index + 1)
      .padStart(2, '0');


  const total =
    String(slides.length)
      .padStart(2, '0');


  counter.textContent =
    `${current} / ${total}`;

}


    const previousButton =
      carousel.querySelector(
        '[data-product-card-carousel-arrow="prev"]'
      );


    const nextButton =
      carousel.querySelector(
        '[data-product-card-carousel-arrow="next"]'
      );


    if (previousButton) {
      previousButton.disabled =
        index <= 0;
    }


    if (nextButton) {
      nextButton.disabled =
        index >= slides.length - 1;
    }
  };


  /*
   * ----------------------------------------------------------
   * DESKTOP ARROWS
   * ----------------------------------------------------------
   */

  document.addEventListener(
    'click',

    (event) => {

      const button =
        event.target.closest?.(
          '[data-product-card-carousel-arrow]'
        );


      if (!button) {
        return;
      }


      event.preventDefault();

      event.stopPropagation();

      event.stopImmediatePropagation();


      const carousel =
        button.closest(
          '[data-product-card-carousel]'
        );


      if (!carousel) {
        return;
      }


      const viewport =
        carousel.querySelector(
          '[data-product-card-carousel-viewport]'
        );


      if (!viewport) {
        return;
      }


      const slides =
        getSlides(viewport);


      if (slides.length < 2) {
        return;
      }


      const current =
        getIndex(viewport);


      const direction =
        button.dataset.productCardCarouselArrow ===
        'next'
          ? 1
          : -1;


      const nextIndex =
        Math.max(
          0,
          Math.min(
            slides.length - 1,
            current + direction
          )
        );


      viewport.scrollTo({
        left:
          nextIndex *
          viewport.clientWidth,

        behavior: 'smooth'
      });


      /*
       * Update immediately,
       * then scroll event keeps it correct.
       */

      window.setTimeout(
        () => updateUI(viewport),
        100
      );

    },

    true
  );


  /*
   * Stop Dawn's card click handling as soon as
   * an arrow interaction starts.
   */

  const stopArrowEvent = (event) => {

    const button =
      event.target.closest?.(
        '[data-product-card-carousel-arrow]'
      );


    if (!button) {
      return;
    }


    event.stopPropagation();

  };


  document.addEventListener(
    'pointerdown',
    stopArrowEvent,
    true
  );


  document.addEventListener(
    'mousedown',
    stopArrowEvent,
    true
  );


  document.addEventListener(
    'touchstart',
    stopArrowEvent,
    true
  );


  /*
   * ----------------------------------------------------------
   * NATIVE SWIPE / SCROLL
   * ----------------------------------------------------------
   *
   * We DO NOT animate the swipe ourselves.
   *
   * Browser performs the actual physical scrolling,
   * momentum and dragging.
   */

  const scrollFrames =
    new WeakMap();


  document.addEventListener(
    'scroll',

    (event) => {

      const viewport =
        event.target.closest?.(
          '[data-product-card-carousel-viewport]'
        );


      if (!viewport) {
        return;
      }


      const existingFrame =
        scrollFrames.get(viewport);


      if (existingFrame) {
        cancelAnimationFrame(
          existingFrame
        );
      }


      const frame =
        requestAnimationFrame(
          () => {

            updateUI(viewport);

            scrollFrames.delete(
              viewport
            );

          }
        );


      scrollFrames.set(
        viewport,
        frame
      );

    },

    true
  );


  /*
   * ----------------------------------------------------------
   * PREVENT PRODUCT OPEN AFTER A SWIPE
   * ----------------------------------------------------------
   *
   * A normal tap opens product.
   * A horizontal swipe does not.
   */

  let touchState = null;

  let blockCarouselClickUntil = 0;


  document.addEventListener(
    'touchstart',

    (event) => {

      const viewport =
        event.target.closest?.(
          '[data-product-card-carousel-viewport]'
        );


      if (
        !viewport ||
        event.touches.length !== 1
      ) {
        return;
      }


      const touch =
        event.touches[0];


      touchState = {

        viewport,

        startX:
          touch.clientX,

        startY:
          touch.clientY,

        currentX:
          touch.clientX,

        currentY:
          touch.clientY,

        horizontalMove:
          false

      };

    },

    {
      passive: true,
      capture: true
    }
  );


  document.addEventListener(
    'touchmove',

    (event) => {

      if (
        !touchState ||
        event.touches.length !== 1
      ) {
        return;
      }


      const touch =
        event.touches[0];


      touchState.currentX =
        touch.clientX;


      touchState.currentY =
        touch.clientY;


      const deltaX =
        Math.abs(
          touchState.currentX -
          touchState.startX
        );


      const deltaY =
        Math.abs(
          touchState.currentY -
          touchState.startY
        );


      if (
        deltaX > 8 &&
        deltaX > deltaY
      ) {

        touchState.horizontalMove =
          true;

      }

    },

    {
      passive: true,
      capture: true
    }
  );


  document.addEventListener(
    'touchend',

    () => {

      if (!touchState) {
        return;
      }


      if (
        touchState.horizontalMove
      ) {

        blockCarouselClickUntil =
          Date.now() + 500;


        /*
         * Native scroll snapping may still
         * be completing when touchend fires.
         */

        const viewport =
          touchState.viewport;


        window.setTimeout(
          () => updateUI(viewport),
          120
        );


        window.setTimeout(
          () => updateUI(viewport),
          300
        );

      }


      touchState = null;

    },

    {
      passive: true,
      capture: true
    }
  );


  document.addEventListener(
    'touchcancel',

    () => {
      touchState = null;
    },

    true
  );


  /*
   * Capture click BEFORE Dawn's full-card link.
   */

  document.addEventListener(
    'click',

    (event) => {

      if (
        Date.now() >
        blockCarouselClickUntil
      ) {
        return;
      }


      const slide =
        event.target.closest?.(
          '[data-product-card-carousel-slide]'
        );


      if (!slide) {
        return;
      }


      event.preventDefault();

      event.stopPropagation();

      event.stopImmediatePropagation();

    },

    true
  );


  /*
   * ----------------------------------------------------------
   * INITIALIZE EXISTING CARDS
   * ----------------------------------------------------------
   *
   * Dynamic recommendation cards don't need
   * initialization because every event handler
   * above is delegated.
   */

  document
    .querySelectorAll(
      '[data-product-card-carousel-viewport]'
    )
    .forEach(
      (viewport) => {
        updateUI(viewport);
      }
    );

})();